// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__wVF9u","categoriesWrapper":"home_categoriesWrapper__uMHpE","category":"home_category__MbaS4","categoryImg":"home_categoryImg__jpgZ1"};